tinymce.addI18n("fi", {
    "#": "#",
    "Accessibility": "Saavutettavuus",
    "Accordion": "Haitarivalikko",
    "Accordion body...": "Haitarivalikon sis\xe4lt\xf6...",
    "Accordion summary...": "Haitarivalikon yhteenveto...",
    "Action": "Toiminto",
    "Activity": "Aktiviteetit",
    "Address": "Osoite",
    "Advanced": "Lis\xe4asetukset",
    "Align": "Tasaa",
    "Align center": "Tasaa keskelle",
    "Align left": "Tasaa vasemmalle",
    "Align right": "Tasaa oikealle",
    "Alignment": "Tasaus",
    "Alignment {0}": "Tasaus {0}",
    "All": "Kaikki",
    "Alternative description": "Vaihtoehtoinen kuvaus",
    "Alternative source": "Vaihtoehtoinen l\xe4hde",
    "Alternative source URL": "Vaihtoehtoinen l\xe4hde-URL",
    "Anchor": "Ankkuri",
    "Anchor...": "Ankkuri...",
    "Anchors": "Ankkurit",
    "Animals and Nature": "El\xe4imet ja luonto",
    "Arrows": "Nuolet",
    "B": "S",
    "Background color": "Taustan v\xe4ri",
    "Background color {0}": "Taustav\xe4ri {0}",
    "Black": "Musta",
    "Block": "Lohko",
    "Block {0}": "Osio {0}",
    "Blockquote": "Lohkolainaus",
    "Blocks": "Lohkot",
    "Blue": "Sininen",
    "Blue component": "Sininen komponentti",
    "Body": "Runko",
    "Bold": "Lihavoitu",
    "Border": "Reunus",
    "Border color": "Reunuksen v\xe4ri",
    "Border style": "Reunuksen tyyli",
    "Border width": "Reunuksen leveys",
    "Bottom": "Ala",
    "Browse files": "Selaa tiedostoja",
    "Browse for an image": "Selaa kuvia",
    "Browse links": "Selaa linkkej\xe4",
    "Bullet list": "J\xe4rjest\xe4m\xe4t\xf6n lista",
    "Cancel": "Peruuta",
    "Caption": "Seloste",
    "Cell": "Solu",
    "Cell padding": "Solun tyhj\xe4 tila",
    "Cell properties": "Solun ominaisuudet",
    "Cell spacing": "Solun v\xe4li",
    "Cell styles": "Solun tyylit",
    "Cell type": "Solutyyppi",
    "Center": "Keskitetty",
    "Characters": "Merkki\xe4",
    "Characters (no spaces)": "Merkki\xe4 (ilman v\xe4lily\xf6ntej\xe4)",
    "Circle": "Ympyr\xe4",
    "Class": "Luokka",
    "Clear formatting": "Poista muotoilu",
    "Close": "Sulje",
    "Code": "Koodi",
    "Code sample...": "Koodin\xe4yte...",
    "Code view": "Koodin\xe4kym\xe4",
    "Color Picker": "V\xe4rivalitsin",
    "Color swatch": "V\xe4rin\xe4yte",
    "Cols": "Sarakkeet",
    "Column": "Sarake",
    "Column clipboard actions": "Sarakkeen leikep\xf6yt\xe4toiminnot",
    "Column group": "Sarakeryhm\xe4",
    "Column header": "Sarakkeen otsikko",
    "Constrain proportions": "Rajauksen mittasuhteet",
    "Copy": "Kopioi",
    "Copy column": "Kopioi sarake",
    "Copy row": "Kopioi rivi",
    "Could not find the specified string.": "Haettua merkkijonoa ei l\xf6ytynyt.",
    "Could not load emojis": "Emojeita ei voitu ladata",
    "Count": "M\xe4\xe4r\xe4",
    "Currency": "Valuutta",
    "Current window": "Nykyinen ikkuna",
    "Custom color": "Mukautettu v\xe4ri",
    "Custom...": "Mukautettu...",
    "Cut": "Leikkaa",
    "Cut column": "Leikkaa sarake",
    "Cut row": "Leikkaa rivi",
    "Dark Blue": "Tummansininen",
    "Dark Gray": "Tummanharmaa",
    "Dark Green": "Tumma vihre\xe4",
    "Dark Orange": "Tumma oranssi",
    "Dark Purple": "Tummanvioletti",
    "Dark Red": "Tumma punainen",
    "Dark Turquoise": "Tumma turkoosi",
    "Dark Yellow": "Tummankeltainen",
    "Dashed": "Katkoviiva",
    "Date/time": "P\xe4iv\xe4m\xe4\xe4r\xe4/aika",
    "Decrease indent": "Sisenn\xe4",
    "Default": "Oletus",
    "Delete accordion": "Poista haitarivalikko",
    "Delete column": "Poista sarake",
    "Delete row": "Poista rivi",
    "Delete table": "Poista taulukko",
    "Dimensions": "Mitat",
    "Disc": "Py\xf6ryl\xe4",
    "Div": "Div",
    "Document": "Tiedosto",
    "Dotted": "Pisteet",
    "Double": "Kaksinkertainen",
    "Drop an image here": "Pudota kuva t\xe4h\xe4n",
    "Dropped file type is not supported": "Pudotettu tiedostotyyppi ei ole tuettu",
    "Edit": "Muokkaa",
    "Embed": "Upota",
    "Emojis": "Emojit",
    "Emojis...": "Emojit...",
    "Error": "Virhe",
    "Error: Form submit field collision.": "Virhe: lomakkeen l\xe4hetyskent\xe4n t\xf6rm\xe4ys.",
    "Error: No form element found.": "Virhe: muotoelementti\xe4 ei l\xf6ytynyt.",
    "Extended Latin": "Laajennettu latina",
    "Failed to initialize plugin: {0}": "Liit\xe4nn\xe4isen alustus ep\xe4onnistui: {0}",
    "Failed to load plugin url: {0}": "Liit\xe4nn\xe4isen url:n lataus ep\xe4onnistui: {0}",
    "Failed to load plugin: {0} from url {1}": "Liit\xe4nn\xe4isen lataus ep\xe4onnistui: {0} url:st\xe4 {1}",
    "Failed to upload image: {0}": "Kuvan lataus ep\xe4onnistui: {0}",
    "File": "Tiedosto",
    "Find": "Etsi",
    "Find (if searchreplace plugin activated)": "Etsi (jos etsikorvaa-liit\xe4nn\xe4inen aktiivinen)",
    "Find and Replace": "Etsi ja korvaa",
    "Find and replace...": "Etsi ja korvaa...",
    "Find in selection": "Etsi valinnasta",
    "Find whole words only": "Etsi vain kokonaisia sanoja",
    "Flags": "Liput",
    "Focus to contextual toolbar": "Kohdistus kontekstuaaliseen ty\xf6kalupalkkiin",
    "Focus to element path": "Kohdistus elementin polkuun",
    "Focus to menubar": "Kohdistus valikkoon",
    "Focus to toolbar": "Kohdistus ty\xf6kalupalkkiin",
    "Font": "Fontti",
    "Font size {0}": "Fontin koko {0}",
    "Font sizes": "Fonttikoot",
    "Font {0}": "Fontti {0}",
    "Fonts": "Fontti",
    "Food and Drink": "Ruoka ja juoma",
    "Footer": "Alatunniste",
    "Format": "Muotoilu",
    "Format {0}": "Tekstin muotoilu {0}",
    "Formats": "Muotoilut",
    "Fullscreen": "Kokon\xe4ytt\xf6",
    "G": "V",
    "General": "Yleiset asetukset",
    "Gray": "Harmaa",
    "Green": "Vihre\xe4",
    "Green component": "Vihre\xe4 komponentti",
    "Groove": "Ura",
    "Handy Shortcuts": "K\xe4tev\xe4t pikan\xe4pp\xe4imet",
    "Header": "Yl\xe4tunniste",
    "Header cell": "Otsikkosolu",
    "Heading 1": "Otsikko 1",
    "Heading 2": "Otsikko 2",
    "Heading 3": "Otsikko 3",
    "Heading 4": "Otsikko 4",
    "Heading 5": "Otsikko 5",
    "Heading 6": "Otsikko 6",
    "Headings": "Otsikot",
    "Height": "Korkeus",
    "Help": "Ohje",
    "Hex color code": "Heksav\xe4rikoodi",
    "Hidden": "Piilotettu",
    "Horizontal align": "Vaakasuuntainen tasaus",
    "Horizontal line": "Vaakasuora viiva",
    "Horizontal space": "Vaakasuuntainen v\xe4li",
    "ID": "ID",
    "ID should start with a letter, followed only by letters, numbers, dashes, dots, colons or underscores.": "ID:n tulisi alkaa kirjaimella, jota seuraa vain kirjaimia, numeroita, v\xe4liviivoja, pisteit\xe4, kaksoispisteit\xe4 tai alaviivoja.",
    "Image is decorative": "Kuva on koristeellinen",
    "Image list": "Kuvaluettelo",
    "Image title": "Kuvan otsikko",
    "Image...": "Kuva...",
    "ImageProxy HTTP error: Could not find Image Proxy": "ImageProxy HTTP-virhe: Kuvaproxy\xe4 ei l\xf6ytynyt",
    "ImageProxy HTTP error: Incorrect Image Proxy URL": "ImageProxy HTTP-virhe: V\xe4\xe4r\xe4 kuvaproxyn osoite",
    "ImageProxy HTTP error: Rejected request": "ImageProxy HTTP-virhe: Pyynt\xf6 hyl\xe4ttiin",
    "ImageProxy HTTP error: Unknown ImageProxy error": "ImageProxy HTTP-virhe: Tuntematon ImageProxy-virhe",
    "Increase indent": "Loitonna",
    "Inline": "Samalla rivill\xe4",
    "Insert": "Lis\xe4\xe4",
    "Insert Template": "Lis\xe4\xe4 malli",
    "Insert accordion": "Lis\xe4\xe4 haitarivalikko",
    "Insert column after": "Lis\xe4\xe4 sarake j\xe4lkeen",
    "Insert column before": "Lis\xe4\xe4 sarake ennen",
    "Insert date/time": "Lis\xe4\xe4 p\xe4iv\xe4m\xe4\xe4r\xe4 tai aika",
    "Insert image": "Lis\xe4\xe4 kuva",
    "Insert link (if link plugin activated)": "Lis\xe4\xe4 linkki (jos linkki-liit\xe4nn\xe4inen aktiivinen)",
    "Insert row after": "Lis\xe4\xe4 rivi j\xe4lkeen",
    "Insert row before": "Lis\xe4\xe4 rivi ennen",
    "Insert table": "Lis\xe4\xe4 taulukko",
    "Insert template...": "Lis\xe4\xe4 malli...",
    "Insert video": "Lis\xe4\xe4 video",
    "Insert/Edit code sample": "Lis\xe4\xe4/muokkaa koodiesimerkki",
    "Insert/edit image": "Lis\xe4\xe4 kuva/muokkaa kuvaa",
    "Insert/edit link": "Lis\xe4\xe4 linkki/muokkaa linkki\xe4",
    "Insert/edit media": "Lis\xe4\xe4 media/muokkaa mediaa",
    "Insert/edit video": "Lis\xe4\xe4 video/muokkaa videota",
    "Inset": "Upotettu",
    "Invalid hex color code: {0}": "Kelvoton heksav\xe4rikoodi: {0}",
    "Invalid input": "Kelvoton sy\xf6te",
    "Italic": "Kursivoitu",
    "Justify": "Tasaus",
    "Keyboard Navigation": "Navigointi n\xe4pp\xe4imist\xf6ll\xe4",
    "Language": "Kieli",
    "Learn more...": "Lis\xe4tietoja...",
    "Left": "Vasen",
    "Left to right": "Vasemmalta oikealle",
    "Light Blue": "Vaaleansininen",
    "Light Gray": "Vaaleanharmaa",
    "Light Green": "Vaaleanvihre\xe4",
    "Light Purple": "Liila",
    "Light Red": "Vaaleanpunainen",
    "Light Yellow": "Vaaleankeltainen",
    "Line height": "Tekstirivin korkeus",
    "Link list": "Linkkiluettelo",
    "Link...": "Linkki...",
    "List Properties": "Listan ominaisuudet",
    "List properties...": "Listan ominaisuudet...",
    "Loading emojis...": "Ladataan emojeita...",
    "Loading...": "Ladataan...",
    "Lower Alpha": "Pienet kirjaimet",
    "Lower Greek": "pienet kirjaimet: \u03b1, \u03b2, \u03b3",
    "Lower Roman": "Numerot, alarivi",
    "Match case": "Sama kirjainkoko",
    "Mathematical": "Matemaattiset",
    "Media poster (Image URL)": "Median julkaisija (kuvan URL)",
    "Media...": "Media...",
    "Medium Blue": "Keskitumma sininen",
    "Medium Gray": "Keskiharmaa",
    "Medium Purple": "Keskitumma purppura",
    "Merge cells": "Yhdist\xe4 solut",
    "Middle": "Keski",
    "Midnight Blue": "keskiy\xf6n sininen",
    "More...": "Lis\xe4\xe4...",
    "Name": "Nimi",
    "Navy Blue": "Laivastonsininen",
    "New document": "Uusi asiakirja",
    "New window": "Uusi ikkuna",
    "Next": "Seuraava",
    "No": "Ei",
    "No alignment": "Ei tasausta",
    "No color": "Ei v\xe4ri\xe4",
    "Nonbreaking space": "Sitova v\xe4lily\xf6nti",
    "None": "Ei mit\xe4\xe4n",
    "Numbered list": "J\xe4rjestetty lista",
    "OR": "TAI",
    "Objects": "Esineet",
    "Ok": "Ok",
    "Open help dialog": "Avaa ohjeen valintaikkuna",
    "Open link": "Avaa linkki",
    "Open link in...": "Avaa linkki...",
    "Open popup menu for split buttons": "Avaa ponnahdusikkuna jaetuille napeille",
    "Orange": "Oranssi",
    "Outset": "Korotettu",
    "Page break": "Sivunvaihto",
    "Paragraph": "Kappale",
    "Paste": "Liit\xe4",
    "Paste as text": "Liit\xe4 tekstin\xe4",
    "Paste column after": "Liit\xe4 sarake j\xe4lkeen",
    "Paste column before": "Liit\xe4 sarake ennen",
    "Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.": "Liitt\xe4minen on nyt pelk\xe4ss\xe4 tekstin tilassa. Sis\xe4lt\xf6 liitet\xe4\xe4n nyt pelkk\xe4n\xe4 tekstin\xe4, kunnes otat asetuksen pois p\xe4\xe4lt\xe4.",
    "Paste or type a link": "Liit\xe4 tai kirjoita linkki",
    "Paste row after": "Liit\xe4 rivi j\xe4lkeen",
    "Paste row before": "Liit\xe4 rivi ennen",
    "Paste your embed code below:": "Liit\xe4 upotuskoodisi alapuolelle:",
    "People": "Ihmiset",
    "Plugins": "Laajennukset",
    "Plugins installed ({0}):": "Asennetut liit\xe4nn\xe4iset ({0}):",
    "Powered by {0}": "Tarjoaja: {0}",
    "Pre": "Pre",
    "Preferences": "Asetukset",
    "Preformatted": "Esimuotoiltu",
    "Premium plugins:": "Premium-liit\xe4nn\xe4iset:",
    "Press the Up and Down arrow keys to resize the editor.": "Muuta editorin kokoa yl\xf6s- ja alas-nuolin\xe4pp\xe4imill\xe4.",
    "Press the arrow keys to resize the editor.": "Muuta editorin kokoa nuolin\xe4pp\xe4imill\xe4.",
    "Press {0} for help": "Avaa ohje painamalla {0}",
    "Preview": "Esikatselu",
    "Previous": "Edellinen",
    "Print": "Tulosta",
    "Print...": "Tulosta",
    "Purple": "Purppura",
    "Quotations": "Lainaukset",
    "R": "P",
    "Range 0 to 255": "V\xe4lill\xe4 0\u2013255",
    "Red": "Punainen",
    "Red component": "Punainen komponentti",
    "Redo": "Tee uudelleen",
    "Remove": "Poista",
    "Remove color": "Poista v\xe4ri",
    "Remove link": "Poista linkki",
    "Replace": "Korvaa",
    "Replace all": "Korvaa kaikki",
    "Replace with": "Korvaa kohteella",
    "Resize": "Kuvan koon muutos",
    "Restore last draft": "Palauta aiempi luonnos",
    "Reveal or hide additional toolbar items": "N\xe4yt\xe4 tai piilota muut ty\xf6kalupalkin kohteet",
    "Rich Text Area": "Rikastetun tekstin alue",
    "Rich Text Area. Press ALT-0 for help.": "Rikastetun tekstin alue. Avaa ohje painamalla ALT-0.",
    "Rich Text Area. Press ALT-F9 for menu. Press ALT-F10 for toolbar. Press ALT-0 for help": "Rikastetun tekstin alue. Paina ALT-F9 valikkoon. Paina ALT-F10 ty\xf6kaluriviin. Paina ALT-0 ohjeeseen.",
    "Ridge": "Harjanne",
    "Right": "Oikea",
    "Right to left": "Oikealta vasemmalle",
    "Row": "Rivi",
    "Row clipboard actions": "Rivin leikep\xf6yt\xe4toiminnot",
    "Row group": "Riviryhm\xe4",
    "Row header": "Rivin otsikko",
    "Row properties": "Rivin ominaisuudet",
    "Row type": "Rivityyppi",
    "Rows": "Rivit",
    "Save": "Tallenna",
    "Save (if save plugin activated)": "Tallenna (jos tallenna-liit\xe4nn\xe4inen aktiivinen)",
    "Scope": "Laajuus",
    "Search": "Etsi",
    "Select all": "Valitse kaikki",
    "Select...": "Valitse...",
    "Selection": "Valinta",
    "Shortcut": "Pikavalinta",
    "Show blocks": "N\xe4yt\xe4 lohkot",
    "Show caption": "N\xe4yt\xe4 kuvateksti",
    "Show invisible characters": "N\xe4yt\xe4 n\xe4kym\xe4tt\xf6m\xe4t merkit",
    "Size": "Koko",
    "Solid": "Yksinkertainen",
    "Source": "L\xe4hde",
    "Source code": "L\xe4hdekoodi",
    "Special Character": "Erikoismerkki",
    "Special character...": "Erikoismerkki...",
    "Split cell": "Jaa solu",
    "Square": "Neli\xf6",
    "Start list at number": "Aloita lista numerosta",
    "Strikethrough": "Yliviivaus",
    "Style": "Tyyli",
    "Subscript": "Alaindeksi",
    "Superscript": "Yl\xe4indeksi",
    "Switch to or from fullscreen mode": "Vaihda kokon\xe4ytt\xf6\xf6n tai kokon\xe4yt\xf6st\xe4",
    "Symbols": "Symbolit",
    "System Font": "J\xe4rjestelm\xe4fontti",
    "Table": "Taulukko",
    "Table caption": "Taulukon selitysteksti",
    "Table properties": "Taulukon ominaisuudet",
    "Table styles": "Taulukon tyylit",
    "Template": "Malli",
    "Templates": "Mallit",
    "Text": "Teksti",
    "Text color": "Tekstin v\xe4ri",
    "Text color {0}": "Tekstin v\xe4ri {0}",
    "Text to display": "N\xe4ytett\xe4v\xe4 teksti",
    "The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?": "Antamasi osoite n\xe4ytt\xe4\xe4 olevan s\xe4hk\xf6postiosoite. Haluatko lis\xe4t\xe4 osoitteeseen vaaditun mailto: -etuliitteen?",
    "The URL you entered seems to be an external link. Do you want to add the required http:// prefix?": "Antamasi osoite n\xe4ytt\xe4\xe4 olevan ulkoinen linkki. Haluatko lis\xe4t\xe4 osoitteeseen vaaditun http:// -etuliitteen?",
    "The URL you entered seems to be an external link. Do you want to add the required https:// prefix?": "Sy\xf6tt\xe4m\xe4si osoite n\xe4ytt\xe4\xe4 olevan ulkoinen linkki. Haluatko lis\xe4t\xe4 vaaditun https://-etuliitteen?",
    "Title": "Otsikko",
    "To open the popup, press Shift+Enter": "Avaa ponnahdusikkuna painamalla Shift+Enter",
    "Toggle accordion": "Avaa/sulje haitarivalikko",
    "Tools": "Ty\xf6kalut",
    "Top": "Yl\xe4",
    "Travel and Places": "Matkailu ja paikat",
    "Turquoise": "Turkoosi",
    "Underline": "Alleviivaus",
    "Undo": "Kumoa",
    "Upload": "Vie",
    "Uploading image": "Ladataan kuvaa",
    "Upper Alpha": "Isot kirjaimet",
    "Upper Roman": "Numerot, yl\xe4rivi",
    "Url": "Osoite",
    "User Defined": "K\xe4ytt\xe4j\xe4m\xe4\xe4ritetty",
    "Valid": "Voimassa",
    "Version": "Versio",
    "Vertical align": "Pystysuuntainen tasaus",
    "Vertical space": "Pystysuuntainen v\xe4li",
    "View": "N\xe4yt\xe4",
    "Visual aids": "Visuaaliset neuvot",
    "Warn": "Varoitus",
    "White": "Valkoinen",
    "Width": "Leveys",
    "Word count": "Sanam\xe4\xe4r\xe4",
    "Words": "Sanaa",
    "Words: {0}": "Sanat: {0} ",
    "Yellow": "Keltainen",
    "Yes": "Kyll\xe4",
    "You are using {0}": "K\xe4yt\xe4t {0}",
    "You have unsaved changes are you sure you want to navigate away?": "Sinulla on tallentamattomia muutoksia, haluatko varmasti siirty\xe4 toiselle sivulle?",
    "Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X/C/V keyboard shortcuts instead.": "Selaimesi ei tue leikep\xf6yd\xe4n suoraa k\xe4ytt\xe4mist\xe4. Ole hyv\xe4 ja k\xe4yt\xe4 n\xe4pp\xe4imist\xf6n Ctrl+X/C/V n\xe4pp\xe4inyhdistelmi\xe4.",
    "alignment": "tasaus",
    "austral sign": "australin merkki",
    "cedi sign": "cedin merkki",
    "colon sign": "kaksoispisteen merkki",
    "cruzeiro sign": "cruzeiro-merkki",
    "currency sign": "valuuttamerkki",
    "dollar sign": "dollarimerkki",
    "dong sign": "dongin merkki",
    "drachma sign": "drakman merkki",
    "euro-currency sign": "eurovaluuttamerkki",
    "example": "esimerkki",
    "formatting": "muotoiltu",
    "french franc sign": "ranskalaisen frangin merkki",
    "german penny symbol": "saksalaisen pennin merkki",
    "guarani sign": "guaranin merkki",
    "history": "historia",
    "hryvnia sign": "hryvnian merkki",
    "indentation": "sisennys",
    "indian rupee sign": "intialaisen rupian merkki",
    "kip sign": "kipin merkki",
    "lira sign": "liiran merkki",
    "livre tournois sign": "livre tournoisin merkki",
    "manat sign": "manatin merkki",
    "mill sign": "millin merkki",
    "naira sign": "nairan merkki",
    "new sheqel sign": "uuden sekelin merkki",
    "nordic mark sign": "pohjoismaisen markan merkki",
    "peseta sign": "pesetan merkki",
    "peso sign": "peson merkki",
    "ruble sign": "ruplan merkki",
    "rupee sign": "rupian merkki",
    "spesmilo sign": "spesmilon merkki",
    "styles": "tyylit",
    "tenge sign": "tengen merkki",
    "tugrik sign": "tugrikin merkki",
    "turkish lira sign": "turkkilaisen liiran merkki",
    "won sign": "wonin merkki",
    "yen character": "jenin merkki",
    "yen/yuan character variant one": "jenin/juanin merkin variantti",
    "yuan character": "juanin merkki",
    "yuan character, in hong kong and taiwan": "juanin merkki, Hongkongissa ja Taiwanissa",
    "{0} characters": "{0} merkki\xe4",
    "{0} columns, {1} rows": "{0} saraketta, {1} rivi\xe4",
    "{0} words": "{0} sanaa"
});